import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { CurrentUserAndPermissions } from './current-user-and-permissions';
import { CurrentUserService } from './current-user.service';

@Injectable()
export class CurrentUserGuard implements Resolve<CurrentUserAndPermissions> {
  constructor(private currentUserService: CurrentUserService) {}

  resolve(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<CurrentUserAndPermissions> {
    return this.currentUserService.getCurrentUser();
  }
}
